import Vue from 'vue';

const success = ({ data }, resolve) => {
  resolve(data);
};

const failed = () => {
};


export default (params = '') => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/account/default-language-n-currency?${params}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/defaultLanguageNCurrency.js